import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var ProfilesTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(ProfilesTransformer, _BaseTransformer);
  var _super = _createSuper(ProfilesTransformer);
  function ProfilesTransformer() {
    _classCallCheck(this, ProfilesTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(ProfilesTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        profileId: data.profile_id,
        profileName: data.profile_name
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return ProfilesTransformer;
}(BaseTransformer);